<template>
  <div>

    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-2">
      <h6 class="m-0 font-weight-bold text-primary">POTONGAN / IURAN</h6>
    </div>

    <div class="card shadow mb-4">
      <div class="card-header">
        <b-row>
          <b-col md="4" class="my-1">
            <div class="form-group">
              <v-select
                v-model="filter.salaryCutType"
                :options="listSalaryCutTypes"
                :reduce="item => item.ID"
                placeholder="pilih tipe potongan"
                label="Name"
                @input="fetchData()"/>
            </div>            
          </b-col>

          <b-col md="4" class="my-1">
            <div class="form-group">
              <v-select
                v-model="filter.employee"
                :options="listEmployees"
                :reduce="item => item.ID"
                placeholder="Pilih pegawai"
                label="Name"
                @input="fetchData()"/>
            </div>
          </b-col>

          <b-col md="4" class="my-1 text-right">
            <a href="#" v-b-modal.modalNewForm class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
              <i class="fas fa-plus text-white-50" /> Lengkapi Data
            </a>
          </b-col>
        </b-row>
      </div>

      <div class="card-body">
        <div class="table-responsive">

          <b-table
            show-empty
            stacked="md"
            :items="tableItems"
            :fields="tableFields"
            :current-page="currentPage">

            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>

            <template v-slot:cell(SalaryCutType)="data">
              {{ data.value.Name }}
            </template>

            <template v-slot:cell(Employee)="data">
              <span v-if="data.value.ID">
                {{ data.value.Name }}
              </span>
              <span v-else>-</span>
            </template>

            <template v-slot:cell(Amount)="data">
              <div
                @dblclick="editRow(data.item.ID, data.index)"
                 v-show="!tableItems[data.index].isUpdate">
                {{ data.value | formatRupiah }}
              </div>
              <input
                :ref="'input_' + data.item.ID"
                class="form-control form-control-sm"
                v-show="tableItems[data.index].isUpdate"
                @keyup.esc="tableItems[data.index].isUpdate = false"
                @keyup.enter="saveRow($event.target.value, data.item.ID, data.index)">
            </template>

            <template v-slot:cell(actions)="data">
              <div class="text-right">
                <b-button
                  v-if="!data.item.isUpdate"
                  size="sm"
                  variant="warning"
                  @click="editRow(data.item.ID, data.index)"
                  class="mr-1">
                  <i class="fas fa-edit" />
                </b-button>

                <b-button
                  size="sm"
                  variant="warning"
                  @click="saveRow($refs['input_' + data.item.ID].value, data.item.ID, data.index)"
                  class="mr-1" v-else>

                  <i class="fas fa-save" />
                </b-button>

                <b-button size="sm" variant="danger" @click="deleteRow(data.item.ID)" class="mr-1">
                  <i class="fas fa-trash" />
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <b-row class="mb-2">
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Tampilkan" class="mb-0">
          <b-form-select
            v-model="perPage"
            :options="pageOptions"
            @change="onPageSizeChange" />
        </b-form-group>
      </b-col>

      <b-col md="6" class="my-1">
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          class="my-0"
          @change="onPageChange"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-modal id="modalNewForm" hide-footer hide-header>
      <form @submit.prevent="false">
        <div class="d-block">

          <div class="form-group">
            <label>Tipe Potongan/Iuran</label>
            <v-select
              v-model="selectedSalaryCutType"
              :options="listSalaryCutTypes"
              label="Name"
              @input="selectSalartCutType" />
          </div>

          <div class="form-group" v-if="selectedSalaryCutType && selectedSalaryCutType.IsIndividual === 1">
            <label>Pegawai</label>
            <v-select
              v-model="form.EmployeeID"
              :options="listEmployees"
              :reduce="item => item.ID"
              label="Name"/>
          </div>

          <div class="form-group" v-show="form.SalaryCutTypeID">
            <label>Potongan</label>
            <input type="number" class="form-control d-block w-100" v-model="form.Amount">
          </div>
        </div>

        <b-button type="button" class="mt-3" block @click="saveNewData" v-show="form.SalaryCutTypeID">
          Simpan
        </b-button>
      </form>
    </b-modal>

  </div>
</template>

<script>


export default {
  middleware: 'auth',
  mounted() {
    this.fetchData()

    this.fetchOptionData()
  },

  data() {
    return {
      tableItems: [],
      tableFields: [
        { key: 'index', label: 'No.', class: 'column-width-20' },
        { key: 'SalaryCutType', label: 'Tipe Potongan' },
        { key: 'Employee', label: 'Pegawai' },
        { key: 'Amount', label: 'Potongan' },
        { key: 'actions', label: '' },
      ],
      totalItems: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30],
      search: '',
      showAddInputBox: false,
      form: {
        SalaryCutTypeID: null,
        EmployeeID: null,
        Amount: null
      },
      listSalaryCutTypes: [],
      listEmployees: [],
      filter: {
        salaryCutType: null,
        employee: null
      },
      selectedSalaryCutType: null
    }
  },

  methods: {
    fetchData () {
      this.$axios.get(`salary-cut`, { params: {
        page: this.currentPage,
        pageSize: this.perPage,
        filterSalaryCutType: this.filter.salaryCutType,
        filterEmployee: this.filter.employee
      }}).then((res) => {
        for (var i = 0; i < res.data.rows.length; i++) {
          res.data.rows[i].isUpdate = false
        }

        this.totalItems = res.data.total
        this.tableItems = res.data.rows
      }).catch(function (error) {
        console.log(error)
      })
    },

    onPageChange (page) {
      this.currentPage = page

      this.fetchData()
    },

    onPageSizeChange (val) {
      this.perPage = val

      this.fetchData()
    },

    onSearch () {
      this.fetchData()
    },

    onResetSearch () {
      this.search = ''

      this.fetchData()
    },

    editRow (refId, index) {
      this.tableItems[index].isUpdate = true

      const ref = 'input_' + refId

      this.$refs[ref].value = this.tableItems[index].Amount

      this.$nextTick(() => {
        this.$refs[ref].focus()
      })
    },

    deleteRow (id) {
      Swal.fire({
        title: 'Anda yakin?',
        text: "Data akan dihapus secara permanen!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Iya, Hapus saja!'
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(`/salary-cut/${id}`).then(res => {
            this.fetchData()

            Swal.fire(
              'Terhapus!',
              'Data berhasil dihapus.',
              'success'
            )
          })
        }

        this.fetchOptionData()
        this.form.SalaryCutTypeID = null
        this.form.EmployeeID = null
        this.form.Amount = null
      })
    },

    toggleAddInputBox () {
      this.showAddInputBox = true

      this.$nextTick(() => {
        this.$refs.inputNew.focus()
      })
    },

    saveRow (value, id, index) {
      if (id === 0) {
        this.$axios.post(`/salary-cut`, { Amount: parseInt(value) }).then(res => {
          this.fetchData()

          this.$bvToast.toast('Berhasil disimpan', {
            title: 'Sukses!!',
            variant: 'success',
            solid: true
          })
        })
      } else {
        this.$axios.post(`/salary-cut/${id}`, { Amount: parseInt(value) }).then(res => {
          this.tableItems[index].Amount = value

          this.$bvToast.toast('Perubahan berhasil disimpan', {
            title: 'Sukses!!',
            variant: 'success',
            solid: true
          })
        })

        this.$nextTick(() => {
          this.tableItems[index].isUpdate = false
        })
      }
    },

    saveNewData () {
      this.form.Amount = parseInt(this.form.Amount, 10)

      this.$axios.post(`/salary-cut`, this.form).then(res => {
        this.fetchData()

        this.$bvToast.toast('Berhasil disimpan', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true
        })

        this.fetchOptionData()
        this.form.SalaryCutTypeID = null
        this.form.EmployeeID = null
        this.form.Amount = null

        this.$bvModal.hide('modalNewForm')
      })

    },

    fetchOptionData () {
      this.$axios.get('/salary-cut-type').then((res) => {
        console.log(res.data)
        this.listSalaryCutTypes = res.data
      }).catch(function (error) {
        console.log(error)
      })

      this.$axios.get('/employee/all', { params: { employeeType: 'blud' } }).then((res) => {
        this.listEmployees = res.data
      }).catch(function (error) {
        console.log(error)
      })
    },

    selectSalartCutType () {
      if (this.selectedSalaryCutType) {
        this.form.SalaryCutTypeID = this.selectedSalaryCutType.ID
      }
    }
  }
}
</script>

<style>
.column-width-20 {
  width: 20px;
}
</style>